import { ICellRendererParams } from "ag-grid-community";
import _ from "lodash";
import { TranslateService } from "projects/shared/src/lib/services/translate.service";

export class AgGridApiTokensSettings {

  constructor(private translate: TranslateService) { }

    public agGridApiTokensSettings = {
    rowModelType: 'infinite',
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: 'single',
    //rowDeselection: true,
    rowHeight: 55,
    enableRangeSelection: true,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 0,
    columnDefs: [
      { field: 'creator_Name', headerName: "Ersteller", sortable: true, filter: true },
      { field: 'id_Created_When', headerName: "Erstellt am", sortable: true, filter: true },
      { field: 'valid_Until', headerName: "Gültig bis", sortable: true, filter: true },
      { 
        //field: 'user_Name',
        valueGetter: (params: any) => {
          //console.log("-----------> params: ", params.data);
          const userName = _.get(params.data, 'user_Name', '');
          return userName !== ' (not confirmed)' ? userName : _.get(params.data, 'user_Email', '');
        },
        //tooltipField: 'useR_EMAIL'
        tooltipValueGetter: (params: any) => {
          return this.getToolTipUserName(params.value, params);
        },
        
        headerName: "Berechtigungsidentität", sortable: true, filter: true },
      // { field: 'last_Name', headerName: `${this.translate.data["USERSLASTNAMECOLUMNHEADER"]}`, sortable: true, filter: true },
      // { field: 'first_Name', headerName: `${this.translate.data["USERSFIRSTNAMECOLUMNHEADER"]}`, sortable: false, filter: false },
      //{ field: 'email', headerName: `${this.translate.data["USERSEMAILCOLUMNHEADER"]}`, sortable: false, filter: false },
      {
        width: 430,
        headerName: `${this.translate.data["USERSACTIONSCOLUMNHEADER"]}`,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          // icon_edit: 'edit',
          // icon_view: 'visibility',
          icon_delete: 'delete',
          // routerLinkEditUser: (params: ICellRendererParams) => `/user-proflie/${_.get(params, 'data.id')}`,
          // routerLinkEditUser: (params: ICellRendererParams) => `/user-profile/${_.get(params, 'data.id')}`,
          // routerLinkViewUser: (params: ICellRendererParams) => `/manage-users/${_.get(params, 'data.id')}`
        },
      },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  }

  getToolTipUserName(name: string, params: any): string {
    return name.includes('@') ? 'Benutzer hatte E-Mail zu diesem Zeitpunkt nicht bestätigt' : _.get(params.data, 'user_Email', '');
  }
}